import React, { useCallback, useEffect, useMemo, useState } from "react";
import EmailsPanel from "./painel-email";
import PhonesPanel from "./painel-fone";
import CompaniesPanel from "./painel-company";
import CompaniesHistoryPanel from "./painel-company-history";
import DeniedCompaniesPanel from "./painel-company-danied";
import { Spin } from "antd";
import {
  getCompanies,
  updateCompany,
} from "services/managerial/managerial-service";
import { notificationErroInternalGeneric } from "util/api-utils";
import HorizontalScrollWrapper from "components/horizontal-scroll-wrapper";

const ManagerialAdmin = () => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [activeCompanies, setActiveCompanies] = useState([]);
  const [deniedCompanies, setDeniedCompanies] = useState([]);

  useEffect(() => {
    const active = companies.filter((c) => !c.isBan);
    const denied = companies.filter((c) => c.isBan);
    setActiveCompanies(active);
    setDeniedCompanies(denied);
  }, [companies]);

  const updateBan = useCallback(async (targetKey, nextBan) => {
    setLoading(true);
    try {
      const obj = {
        isBan: nextBan,
      };
      await updateCompany(targetKey, obj);
      getCompaniesData();
    } catch (error) {
      notificationErroInternalGeneric();
    } finally {
      setLoading(false);
    }
  }, []);

  const onDragStart = useCallback((e, key) => {
    e.dataTransfer.setData("text/company-key", key);
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const onDropToDenied = useCallback(
    (e) => {
      e.preventDefault();
      const key = e.dataTransfer.getData("text/company-key");
      if (key) updateBan(key, true);
    },
    [updateBan]
  );

  const onDropToActive = useCallback(
    (e) => {
      e.preventDefault();
      const key = e.dataTransfer.getData("text/company-key");
      if (key) updateBan(key, false);
    },
    [updateBan]
  );

  const allowDrop = useCallback((e) => e.preventDefault(), []);

  useEffect(() => {
    getCompaniesData();
  }, []);
  const getCompaniesData = async () => {
    setLoading(true);

    try {
      const result = await getCompanies();
      setCompanies(result);
    } catch (error) {
      notificationErroInternalGeneric();
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-managerial-admin">
      <Spin spinning={loading}>
        <HorizontalScrollWrapper style={{ minHeight: "90vh" }}>
          <EmailsPanel protectedView={false} />

          <PhonesPanel protectedView={false} />

          <div
            onDragOver={allowDrop}
            onDrop={onDropToActive}
            className="drop-zone"
            style={{ borderRadius: 12 }}
          >
            <CompaniesPanel
              protectedView={false}
              data={activeCompanies}
              onDragStart={onDragStart}
              setEmpresas={setCompanies}
            />
          </div>
          <div>
            <CompaniesHistoryPanel
              data={companies}
              setEmpresas={setCompanies}
            />
          </div>
          <div
            onDragOver={allowDrop}
            onDrop={onDropToDenied}
            className="drop-zone danger"
            style={{ borderRadius: 12 }}
          >
            <DeniedCompaniesPanel
              data={deniedCompanies}
              onDragStart={onDragStart}
              setEmpresas={setCompanies}
            />
          </div>
        </HorizontalScrollWrapper>
      </Spin>
    </div>
  );
};

export default ManagerialAdmin;
